import React from "react";
import { useLocation } from "react-router-dom";
import OrderDetailPage from "./OrderDetailPage";

/**
 * Wrapper component for OrderDetailPage that handles initial data from navigation state
 * This allows the page to reuse data from the orders list without making additional API calls
 */
const OrderDetailWrapper = () => {
  const location = useLocation();
  const initialOrder = location.state?.order;

  return <OrderDetailPage initialOrder={initialOrder} />;
};

export default OrderDetailWrapper;
